/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
const RE_TRAILING_SLASH = /^\//;
const RE_LEADING_SLASH = /\/$/;
const RE_DOUBLE_SLASH = /\/\//gi;
export function resolvePath(basePath, ...pathParts) {
    for (let p of pathParts) {
        if (p === null || p === undefined) {
            console.log("subPath parts: ", pathParts);
            throw new Error("subPath was given an nullish part");
        }
    }
    var path = pathParts.join("/").replace(RE_DOUBLE_SLASH, "/");
    if (path === undefined) {
        throw new Error(`CollectionEntity.subPath cannot be called with undefined`);
    }
    if (!path || path === "/") {
        return basePath;
    }
    else {
        var pathStart = basePath.replace(RE_TRAILING_SLASH, "");
        var pathEnd = path.replace(RE_LEADING_SLASH, "");
        return `${pathStart}/${pathEnd}`;
    }
}
//# sourceMappingURL=firebase-paths.js.map